export enum UserProgressActionTypes {
  USER_PROGRESS_TRACK = 'USER_PROGRESS_TRACK',
  CLEAR_PROGRESS_FETCH = 'CLEAR_PROGRESS_FETCH'
}
